<template>
    <div v-if="getAdviceDetail != null && Object.entries(getAdviceDetail).length !== 0">
        <div class="d-flex flex-row align-items-center">
            <img src="../../assets/img/advies-mute.svg" alt="advies" height="28">
            <div class="m-l-15"></div>
            <h2 class="m-b-10 sectiontitle-advies">{{ $t('schedule_advice') }}</h2>
        </div>

        <div class="p-t-10 p-b-10">
            <p class="adviestitle">{{ getAdviceDetail.Content.Title }}</p>
        </div>

        <div>
            <FormattedCmsText :content="getAdviceDetail.Content"/>
        </div>

        <div v-if="getAdviceDetail.LinkedAdvices.length > 0"
             class="p-t-10 p-b-10">
            <p class="adviestitle-links">{{ $t('schedule_more_info') }}</p>
            <ul class="list-unstyled">
                <li v-for="linked in getAdviceDetail.LinkedAdvices">
                    <a href="#" @click.prevent="jumpToAdvice(linked.Id)">{{linked.Title}}</a>
                </li>
            </ul>
        </div>

        <div v-if="getAdviceDetail.LinkedRecipes.length > 0"
             class="p-t-10 p-b-10">
            <p class="adviestitle-links">{{ $t('schedule_more_recipes') }}</p>
            <ul class="list-unstyled">
                <li v-for="linked in getAdviceDetail.LinkedRecipes">
                    <a href="#" @click.prevent="jumpToAdvice(linked.Id)">{{linked.Title}}</a>
                </li>
            </ul>
        </div>

        <div v-if="getAdviceDetail.BackLinkedAdvices.length > 0"
             class="p-t-10 p-b-10">
            <p class="adviestitle-links">{{ $t('schedule_back_to_advice') }}</p>
            <ul class="list-unstyled">
                <li v-for="linked in getAdviceDetail.BackLinkedAdvices">
                    <a href="#" @click.prevent="jumpToAdvice(linked.Id)">{{linked.Title}}</a>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import FormattedCmsText from '../utilities/FormattedCmsText'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'AdviceContent',
  components: { FormattedCmsText },
  props: {
  },
  computed: {
    ...mapGetters([
      'getAdviceDetail','getTimeFrame'
    ]),
  },
  methods: {
    ...mapActions([
      'loadAdviceDetails',
    ]),
    jumpToAdvice (adviceId) {
      this.loadAdviceDetails({adviceId: adviceId, timeframeId: this.getTimeFrame}).then(response => {
        console.log(response)
        this.$el.scrollTop = 0
      }, error => {
        console.error(error)
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/myschedule/AdviceContent.vue